import { createRouter } from '@tanstack/react-router';

import { queryClient } from '@core/query/client.js';
import { routeTree } from '../routeTree.gen.js';
import { RethrowToAppErrorBoundary } from './error-boundary.js';

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  // TanStack Query owns data freshness; preloads must not introduce a second
  // staleness layer.
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultErrorComponent: RethrowToAppErrorBoundary,
  // TanStack's global catch boundary renders its own unstyled fallback for any
  // error the per-route boundaries rethrow, swallowing the rethrow before it
  // reaches <AppErrorBoundary> — so neither AppCrashPanel nor Sentry sees it.
  // Disabling it lets RethrowToAppErrorBoundary propagate out to the React boundary.
  disableGlobalCatchBoundary: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
